import { render, staticRenderFns } from "./ViewUserDialog.vue?vue&type=template&id=0d8ac7c5"
import script from "./ViewUserDialog.vue?vue&type=script&lang=js"
export * from "./ViewUserDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports